import { render, staticRenderFns } from "./rain-pipe-detail-info.vue?vue&type=template&id=5dcd0830&scoped=true"
import script from "./rain-pipe-detail-info.vue?vue&type=script&lang=js"
export * from "./rain-pipe-detail-info.vue?vue&type=script&lang=js"
import style0 from "./rain-pipe-detail-info.vue?vue&type=style&index=0&id=5dcd0830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcd0830",
  null
  
)

export default component.exports